import React, { Component } from 'react';
import styled from 'styled-components';
import vhCheck from 'vh-check';
import TextContent from './TextContent';
import ImageContent from './ImageContent';

const Container = styled.div`
    display: flex;
    flex-flow: row nowrap;
    /* border: 1px dashed red; */
`;

class Work extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vh: 0,
      slideNumber: 0,
    };
    this.pageSplitTimes = 1.3;
    this.lastScrollTop = 0;
    this.scrollDirectionDown = true;
    this.handleScroll = this.handleScroll.bind(this);
    this.workDetails = [
      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectType: '',
        roles: [''],
      },
      {
        number: '01',
        projectName: 'BharatPe Mutual Funds',
        projectDesc: 'Leading frontend development for BharatPe Mutual Funds using React and a microfrontend architecture (Module Federation) to integrate the product into the Invest BharatPe app. Streamlined the investment journey from 7 steps to 4 and improved homepage load time by 30% through preloading and eliminating redundant API calls.',
        projectType: 'Sr. Frontend Developer (SDE3)',
        roles: ['React', 'TypeScript', 'Module Federation', 'Microfrontends'],
      },
      {
        number: '02',
        projectName: 'HyperExecute',
        projectDesc: 'We Built a cloud based test execution platform, where users can run their test cases on a cloud base platform and we provide all the required info to users which helps them monitor and streamline their test suits',
        projectType: 'Sr. FrontEnd Developer',
        roles: ['React', 'HTML', 'CSS', 'Node'],
        link:'https://www.lambdatest.com/lp/hyperexecute'
      },
      {
        number: '03',
        projectName: 'Checkout Commercetools',
        projectDesc: "We have built a checkout platform for commercetools, where our customers can easily integrate their storefront with our checkout product. We used React and Node in frontend and BFF.",
        projectType: 'Sr. Frontend Developer',
        roles: ['React', 'HTML', 'CSS', 'FASTIFY', 'GraphQl'],
      },
      {
        number: '04',
        projectName: 'Seek',
        projectDesc: 'Seek is a job platform, as a frontend developer I developed many new features, including user preferences and user details.',
        projectType: 'Sr. FrontEnd Developer',
        roles: ['React', 'HTML', 'CSS', 'Node'],
      },
      {
        number: '05',
        projectName: 'Cat',
        projectDesc: 'At caterpillar I worked on integrating multiple application of caterpillar into single product, where dealer can get product, data or help across the globe.',
        projectType: 'FrontEnd Developer',
        roles: ['Angular', 'HTML', 'CSS', 'Node'],
      },
      {
        number: '06',
        projectName: 'NAB',
        projectDesc: 'At National Australian Bank, We created buy now pay later product and integrated it with the bank application.',
        projectType: 'FrontEnd Developer',
        roles: ['React', 'HTML', 'CSS', 'BFF'],
      },
      {
        number: '07',
        projectName: 'i4option',
        projectDesc: 'i4option is a trading strategy platform, i created its frontend from scratch. Here users can create startegy for option trading using live data from NSE',
        projectType: 'FrontEnd Developer',
        roles: ['React', 'HTML', 'CSS'],
      },
      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectType: '',
        roles: [''],
      },
    ];
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const vhDiff = vhCheck().offset;
    this.setState(
      {
        vh: Math.round(
          (window.document.documentElement.clientHeight + vhDiff) * this.pageSplitTimes,
        ),
      },
    );
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const { body, documentElement } = event.srcElement;
    const { vh, slideNumber } = this.state;
    const scrollDistance = Math.max(body.scrollTop, documentElement.scrollTop);
    if (scrollDistance > this.lastScrollTop) {
      this.scrollDirectionDown = true;
    } else {
      this.scrollDirectionDown = false;
    }
    this.lastScrollTop = scrollDistance;
    // console.log(scrollDistance);

    const maxSlide = this.workDetails.length - 1;
    const targetSlide = Math.min(Math.max(Math.floor(scrollDistance / vh), 0), maxSlide);

    if (targetSlide !== slideNumber
      && slideNumber < maxSlide) {
      this.setState({ slideNumber: targetSlide });
    } else if (slideNumber === maxSlide
      && (targetSlide < slideNumber)) {
      this.setState({ slideNumber: targetSlide });
    }
  }

  changeTextContentBasedOnScroll() {
    const { slideNumber } = this.state;
    const refresh = true;
    return (
      <TextContent
        number={this.workDetails[slideNumber].number}
        projectName={this.workDetails[slideNumber].projectName}
        projectDesc={this.workDetails[slideNumber].projectDesc}
        projectType={this.workDetails[slideNumber].projectType}
        roles={this.workDetails[slideNumber].roles}
        refreshToggle={refresh}
      />
    );
  }

  render() {
    return (
      <Container>
        {this.changeTextContentBasedOnScroll()}
        <ImageContent pageSplitTimes={this.pageSplitTimes} />
      </Container>
    );
  }
}

export default Work;
